export default "__VITE_ASSET__Dhde$Sr6__"